import Box from '@mui/material/Box'
import Container from '@mui/material/Container'
import CssBaseline from '@mui/material/CssBaseline'
import { ThemeProvider } from '@mui/material/styles'
import { ErrorBoundary, Provider } from '@rollbar/react'
import { useAuth } from 'api/auth/hooks'
import Navbar from 'components/applications/Navbar'
import EnvironmentAlert from 'components/shared/EnvironmentAlert'
import Snackbars from 'components/shared/Snackbars'
import TopBar from 'components/topbar'
import type { AppProps } from 'next/app'
import { useState } from 'react'
import { Hydrate, QueryClient, QueryClientProvider } from 'react-query'
import { ReactQueryDevtools } from 'react-query/devtools'
import { theme } from 'styles/theme'
import { rollbarConfig } from 'utils/rollbar'
import '../styles/fonts.css'
import { getEnvironment } from '../utils/environment'

// Start mock server
if (['development', 'test'].includes(getEnvironment())) {
  require('../tests/mocks/server')
}

function MyApp({ Component, pageProps }: AppProps) {
  const [queryClient] = useState(() => new QueryClient())

  useAuth()

  return (
    <Provider config={rollbarConfig}>
      <ErrorBoundary>
        <QueryClientProvider client={queryClient}>
          <ThemeProvider theme={theme}>
            <CssBaseline />
            {/* @ts-expect-error */}
            <Hydrate state={pageProps.dehydratedState}>
              <TopBar />

              <Box display="flex">
                <Container>
                  <Navbar />
                  <Component {...pageProps} />
                  {['development', 'staging'].includes(getEnvironment()) && (
                    <EnvironmentAlert />
                  )}
                </Container>
                <Snackbars />
              </Box>
            </Hydrate>
            {getEnvironment() === 'development' && (
              <ReactQueryDevtools initialIsOpen={false} />
            )}
          </ThemeProvider>
        </QueryClientProvider>
      </ErrorBoundary>
    </Provider>
  )
}

export default MyApp
